<template>
  <div>
    <navbar back fixed>
      <span slot="title">关注微信</span>
    </navbar>
    <div class="page-content">
      <scroller ref="scroller">
        <div class="content">
          <img class="wechat-img" src="./wechat.png">
          <div class="txt">
            <p>多种产品快速申请通道</p>
            <p>在线客服的及时帮助</p>
            <p>为您带来专业的贷款咨询和便捷服务</p>
          </div>
        </div>
      </scroller>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Scroller from 'components/scroller/scroller'

  export default {
    components: {
      Navbar,
      Scroller
    },
    mounted () {
      this.$nextTick(() => {
        if (this.$refs.scroller) {
          setTimeout(() => {
            this.$refs.scroller.resize()
          }, 500)
        }
      })
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .content
    text-align center

    .wechat-img
      width px2rem(300)
      margin-top px2rem(164)
      margin-bottom px2rem(136px)

    .txt
      font-size px2rem(28)
      color #21507f

      p
        margin-top 0
        margin-bottom px2rem(20)
</style>



// WEBPACK FOOTER //
// follow.vue?5635d4f4